import { createSelector } from '@ngrx/store';
import { selectAuthState } from './auth.selectors';

export const selectLoginState = createSelector(
  selectAuthState,
  (state) => state.login,
);

export const getLoginForm = createSelector(
  selectLoginState,
  (state) => state.form,
);
